import { useState } from 'react';
import { useReadState } from '@hooks/useReadState';
import type { IListItem } from '../../ActivitiesPage/model/listItem';
import { AlertDrawerHost } from '../../DashboardPage/Cards/AlertDrawerHost';

/**
 * An activity's or issue's detail drawer, opened from the Monitor — the rail
 * list's cards and the floor drawer's rows alike. As the Activities & Issues
 * page does, opening an item marks it (and its comments) seen. `drawer` is the
 * open item's drawer, or null; render it wherever the opener lives.
 */
export function useItemDrawer(siteId: string) {
  const readState = useReadState(siteId);
  const [openKey, setOpenKey] = useState<string | null>(null);

  const open = (item: IListItem) => {
    readState.markSeen(item.key, item.commentCount);
    setOpenKey(item.key);
  };

  const drawer = openKey ? (
    <AlertDrawerHost siteId={siteId} itemKey={openKey} onClose={() => setOpenKey(null)} />
  ) : null;
  return { open, drawer };
}
